export function formatISOToDate(iso: string): string {
  const dateMatch = iso.match(/([^ ]+)/)
  if (!dateMatch?.length) return ''
  const date = dateMatch[0]

  const today = new Date().toLocaleDateString('en-us', { day: '2-digit', month: '2-digit', year: 'numeric' })
  if (today === date) return 'TODAY'

  return date
}

export function formatISOToTime(iso: string): string {
  const timeMatch = iso.match(/\s(.*)/)
  if (!timeMatch?.length) return ''
  const time = timeMatch[0]

  const hourMatch = time.match(/([^:]+)/)
  if (!hourMatch?.length) return ''
  const unformattedHour = hourMatch[0]
  if (isNaN(Number(unformattedHour))) return ''

  const minuteMatch = time.match(/:([^:]*)/)
  if (!minuteMatch?.length) return ''
  const minute = minuteMatch[0]

  let hour = Number(unformattedHour)
  if (Number(unformattedHour) === 0) hour = 12
  if (Number(unformattedHour) > 12) hour = Number(unformattedHour) % 12

  const amOrPm = Number(unformattedHour) >= 12 ? 'pm' : 'am'

  const formattedTime = `${hour}${minute} ${amOrPm}`
  return formattedTime
}

export function formatISOToDateAndTime(iso: string): string {
  const dateMatch = iso.match(/([^ ]+)/)
  if (!dateMatch?.length) return ''
  const dateStr = dateMatch[0]

  const timeStr = formatISOToTime(iso)

  const dateTime = `${dateStr} at ${timeStr}`
  return dateTime
}

export function formatReceivedTime(receivedTime: string | null): string {
  if (!receivedTime) return 'Not yet received'

  return formatISOToDateAndTime(receivedTime)
}

export const convertISOToSimpleDate = (isoString: string): string => {
  const date = new Date(isoString).toLocaleDateString('en-US', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
  })

  return date
}

export const convertISOToHourAndMinute = (isoString: string): string => {
  const timeWithSeconds = isoString.split('T')[1]
  const time = timeWithSeconds.substring(0, timeWithSeconds.lastIndexOf(':'))

  return time
}

export const convertImageSizeToKB = (imageSize: number): string => {
  const kb = Math.ceil(imageSize / 1000)
  return `${kb} KB`
}

export const filterEkgComments = (comments: string): string => {
  if (comments.toLocaleLowerCase() === 'Vital Signs'.toLocaleLowerCase()) return ''
  if (comments.toLocaleLowerCase() === 'NIBP'.toLocaleLowerCase()) return ''
  if (comments.includes('Code Marker:') || comments.includes('- Code Marker')) return ''

  return comments
}
